import { Box, SidebarModal } from '@domain-group/suit-theme'

import { formatEntityCount } from '@functions/entity'

import type { UseActivitiesPayload } from '@hooks/useActivities'

import Activity from '../Activity'

interface ActivitiesProps {
  activitiesPayload: UseActivitiesPayload,
}

const Activities = (props: ActivitiesProps) => {
  const { activitiesPayload } = props

  const { filteredActivities, filteredActivitiesCount } = activitiesPayload

  const activityText = formatEntityCount({
    entityCount: filteredActivitiesCount,
    entityString: 'Activity',
    entityStringPlural: 'Activities',
  })

  return (
    <SidebarModal.ExpandableSectionBox
      boxProps={{ backgroundColor: 'white', marginTop: 'large' }}
      headerBoxProps={{ paddingX: 0, paddingTop: 0 }}
      contentBoxProps={{ flexDirection: 'column', paddingX: 0 }}
      label={activityText}
    >
      <Box
        flexDirection="column"
        maxHeight={200}
        overflowY="auto"
        variant="white"
      >
        {filteredActivities.map(activity => (
          <Activity activity={activity} key={activity.id} />
        ))}
      </Box>
    </SidebarModal.ExpandableSectionBox>
  )
}

export default Activities
